export default __webpack_public_path__ + "static/base-plus-3-2d9f0ca58ca90125122da0d136b2a300.jpg";